module.exports = __webpack_public_path__ + "media/img/help_center/Student_Profile_06-d2f7ba2e3f2212f30e6d0a087f4ca789.jpg";